import { fallbackLng, Locale, locales } from '@/i18n-config';

export function validateRequiredCheckboxesAreChecked(
  formElement: HTMLFormElement,
  requiredCheckboxes?: string[],
) {
  const checkboxesToValidate =
    requiredCheckboxes ??
    Array.from(formElement.elements)
      .filter(
        (element) =>
          element.getAttribute('type') === 'checkbox' &&
          element.getAttribute('name') !== null,
      )
      .map((element) => element.getAttribute('name')!);

  const formData = new FormData(formElement);
  return checkboxesToValidate.every((name) => formData.get(name) === 'on');
}

export function shouldDisplayInSpanish(pathname: string) {
  const paths = pathname.split('/').filter((path) => !!path);
  const lang = locales.includes(paths[0])
    ? (paths[0] as Locale)
    : (fallbackLng as Locale);
  return lang === 'es' || lang === 'es-US';
}

export enum FieldName {
  FirstName = 'firstName',
  LastName = 'lastName',
  EmailAddress = 'email',
  ConfirmEmailAddress = 'confirmEmail',
  PhoneNumber = 'mdn',
  Address = 'address',
}
